import React, { FunctionComponent } from 'react';
import { Box, Text, Grid, Link, GridItem } from '@chakra-ui/react';

interface IProps {
  title: string;
  jobId: string;
  office: string;
  department: string;
}

const JobListingItem: FunctionComponent<IProps> = ({
  title,
  jobId,
  office,
  department,
}) => (
  <Box width="full" _hover={{ backgroundColor: '#D3E6FA' }}>
    <Link
      href={`/job-details/${jobId}`}
      size="full"
      color="black"
      _hover={{ textDecoration: 'none' }}
    >
      <Box borderBottom="1px" borderColor="#D3E6FA" w="100%" p="6">
        <Grid templateColumns="repeat(3, 1fr)" columnGap="4">
          <GridItem colSpan={1}>
            <Text fontSize={['sm', 'xl']}>{title}</Text>
          </GridItem>
          <GridItem colSpan={1}>
            <Text textAlign="center" fontSize={['sm', 'xl']}>
              {department}
            </Text>
          </GridItem>
          <GridItem colSpan={1}>
            <Text textAlign="center" fontSize={['sm', 'xl']}>
              {office}
            </Text>
          </GridItem>
        </Grid>
      </Box>
    </Link>
  </Box>
);

export default JobListingItem;
